export const routes = {
  userInformation: "users/me",
};
